export default "__VITE_ASSET__BdI5lLAG__ 584w";